import React, { useState } from 'react';
import './FAQ.css';

const faqs = [
  {
    category: 'Design & Installation',
    question: 'When is the best time to start landscaping?',
    answer: 'While spring is ideal for planting and prepping, summer works best for large installation and construction projects, planting trees and shrubs.',
  },
  {
    category: 'Getting Started',
    question: 'What is your approach to my space?',
    answer: 'Our initial client meeting ensures we understand your vision, needs, and lifestyle.',
  },
  {
    category: 'Design & Installation',
    question: 'What is the difference between landscaping, hardscaping and xeriscape?',
    answer: 'Landscaping involves living elements like trees, shrubs, and mulch, whereas xeriscaping is a more sustainable landscaping method designed to minimize or eliminate the need for irrigation. Hardscaping refers to non-living structures like patios, walkways, and retaining walls.',
  },
  {
    category: 'Pricing',
    question: 'How much does landscaping cost?',
    answer: 'Costs vary wildly based on scope, it is essential to define a budget before designing to avoid overspending. Call us today for a quote.',
  },
  {
    category: 'Planting',
    question: 'How do you choose the right plants?',
    answer: 'We choose plants based on your zone, sunlight availability (full sun vs. shade), and soil type.',
  },
  {
    category: 'Maintenance',
    question: 'How often should I aerate my lawn?',
    answer: 'Aeration is usually recommended in the spring or fall to reduce soil compaction and improve nutrient uptake.',
  },
  {
    category: 'Maintenance',
    question: 'What is mulching?',
    answer: 'Covering the soil around plants with materials like wood chips to retain moisture, suppress weeds, and regulate soil temperature.',
  },
  {
    category: 'Permits',
    question: 'Do you handle permits?',
    answer: 'We will manage necessary permits for hardscaping and structural changes.',
  },
];

const FAQ = ({ serviceTag }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);
  const railClass = serviceTag ? 'site-rail site-rail--wide' : 'site-rail site-rail--default';

  return (
    <section className={`faq ${serviceTag ? 'faq--service' : ''}`}>
      <div className={`faq__inner ${railClass}`}>
        <div className="faq__left">
          <div className="faq__tags">
            <span className="faq__tag">FAQ</span>
            {serviceTag && (
              <span className="faq__tag faq__tag--service">{serviceTag}</span>
            )}
          </div>
          <h2 className="faq__heading">Good questions <span className="faq__heading-accent">deserve answers</span></h2>
          <p className="faq__subtext">The things people ask most before they pick up the phone, answered honestly.</p>
        </div>
        <div className="faq__list">
          {faqs.map((item, i) => (
            <div key={i} className={`faq__item ${openIndex === i ? 'faq__item--open' : ''}`}>
              <button className="faq__trigger" onClick={() => toggle(i)} type="button">
                <div className="faq__trigger-left">
                  <span className="faq__category">{item.category}</span>
                  <span className="faq__question">{item.question}</span>
                </div>
                <div className="faq__icon"><span>{openIndex === i ? '−' : '+'}</span></div>
              </button>
              {openIndex === i && (
                <div className="faq__answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
